import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment-timezone';
import Chip from '@material-ui/core/Chip';
import red from '@material-ui/core/colors/red';
import yellow from '@material-ui/core/colors/yellow';
import green from '@material-ui/core/colors/green';
import grey from '@material-ui/core/colors/grey';
import { Typography } from '@material-ui/core';

const columns = [
  { id: 'flight', label: 'Flight', minWidth: 80 },
  { id: 'departure', label: 'Departure', minWidth: 80 },
  { id: 'arrival', label: 'Arrival', minWidth: 80 },
  { id: 'dtime', label: 'Departure Time', minWidth: 80, align: 'center' },
  { id: 'atime', label: 'Arrival Time', minWidth: 80, align: 'center' },
  { id: 'status', label: 'Status', minWidth: 80, align: 'right' },
];


const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  header: {
      backgroundColor:"#121212",
      color: "#fff"
  },
  altRows: {
    '&:nth-of-type(odd)': {
      backgroundColor: '#cecece',
    }
  },
  chip: {
    verticalAlign: 'text-top',
    float: 'right'
  },
  'Unknown': { color: grey[500] },
  'OnTime': { background: green[500] },
  'Arrived': { background: green[500] },
  'Departed': { background: green[500] },
  'Delayed': { background: yellow[500] },
  'Cancelled': { background: red[500] }
});

export default function FlightTable(props) {
  const classes = useStyles();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };


  function createData(flight, departure, arrival, dtime, atime, status) {
    return { flight, departure, arrival, dtime, atime, status };
  }

  let rows = []

  const format = 'ddd, MMM Do [at] h:mm A';

  function formatTime(momentTime, timezone) {
    return (moment.tz(momentTime, timezone).format(format))
  }

  for (let i = 0; i < props.flights.length; i++) {
    let f = props.flights[i]
    const _class = [ classes.chip, classes[f.depart.status.replace(/ /g, ``)] ].join(` `);
    const status = <Chip className={_class} label={f.depart.status} />;

    let departTime = f.depart.estimated.dateTime ? (
      <div>
        <Typography>
          <b>Scheduled</b>: {formatTime(f.depart.scheduled.moment, f.depart.timezone)}
        </Typography>
        <Typography>
          <b>Estimated</b>: {formatTime(f.depart.estimated.moment, f.depart.timezone)}
        </Typography>
      </div>
    ) : formatTime(f.depart.scheduled.moment, f.depart.timezone);

    let arriveTime = f.arrive.estimated.dateTime ? (
      <div>
        <Typography>
          <b>Scheduled</b>: {formatTime(f.arrive.scheduled.moment, f.arrive.timezone)}
        </Typography>
        <Typography>
          <b>Estimated</b>: {formatTime(f.arrive.estimated.moment, f.arrive.timezone)}
        </Typography>
      </div>
    ) : formatTime(f.arrive.scheduled.moment, f.arrive.timezone);

    rows.push(createData(f.flightNumber, f.depart.airport, f.arrive.airport, departTime, arriveTime, status))
  }

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container}>
        {/* sticky header not working for some reason */}
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                  className={classes.header}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
              return (
                <TableRow hover={false} role="checkbox" tabIndex={-1} key={row.flightNumber} className={classes.altRows}>
                  {columns.map((column) => {
                    const value = row[column.id];
                    return (
                      <TableCell key={column.id} align={column.align}>
                        {column.format && typeof value === 'number' ? column.format(value) : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[25, 100]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}



// WEBPACK FOOTER //
// ./src/widgets/FlightStatus/FlightTable.js